import { any, arrayOf, bool, shape, string } from 'prop-types';

export const navRouteType = shape({
  component: any,
  exact: bool,
  nav: bool,
  path: string.isRequired,
  title: string.isRequired,
  disableLink: bool
});

export const navRouteTypes = arrayOf(navRouteType);

export const navLinksTypes = arrayOf(
  shape({
    label: string.isRequired,
    routes: navRouteTypes,
    section: string.isRequired,
    to: string.isRequired,
    hideLink: bool
  })
);
